// Achtung: Wegen der nötigen heightOffset hier eine Sonderlösung, statt es via gba.automatische-iframeheight.js zu implementieren
(function($) {

    var $livestreamMediathekIframe = $('#livestream-mediathek');

    // rufe Helfer-Skript auf frisch geholtem Objekt
    $livestreamMediathekIframe.iframeHeight({
        resizeMaxTry: 10,
        minimumHeight: 100,
        defaultHeight: 250,
        heightOffset: 10 // Höhe des iframe-Inhalt wird wg. negativer Margin und overflow nicht 100% korrekt übermittelt, daher hier gepuffert!
    });

})(jQuery);